import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import TUICustomerServicePlugin from '@tencentcloud/tui-customer-service-plugin/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-customer-service',
  props: {
    message: {
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(TUICustomerServicePlugin, {
        message: props.message
      }, null, 8, ["message"]);
    };
  }
});